import { render, staticRenderFns } from "./BaseAuditStates.vue?vue&type=template&id=24704d2e"
import script from "./BaseAuditStates.vue?vue&type=script&lang=js"
export * from "./BaseAuditStates.vue?vue&type=script&lang=js"
import style0 from "./BaseAuditStates.vue?vue&type=style&index=0&id=24704d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports